import React from 'react';
import { Alert, Row, Col } from 'antd';

import { DescriptionCard } from '../../Common/DescriptionCard';
import { RequestParams } from '../RequestParams';
import { RequestResponseCard } from '../../Common/RequestResponseCard';
import { useAmazonDSPIntegrator } from './useAmazonDSPIntegrator';
import { IntegratorDataSelector } from '../IntegratorDataSelector';

export const AmazonDSPIntegrator = ({ data, isLoading, pods, handlePodId, podId }) => {
  const {
    summary,
    requestParams,
    request,
    response,
    amazonDSPpods,
    availableRequestNumbers,
    requestNumber,
    handleRequestChange,
  } = useAmazonDSPIntegrator(data, pods);

  if (request?.error || response?.error) {
    return <Alert type="error" message={request.error || response.error} />;
  }

  return (
    <>
      <DescriptionCard title="Summary" isLoading={isLoading} data={summary} />
      <RequestParams isLoading={isLoading} request={requestParams} />
      <Row>
        <Col>
          {amazonDSPpods && (
            <IntegratorDataSelector name="Pod" data={amazonDSPpods} handleTargetId={handlePodId} targetId={podId} />
          )}
        </Col>
        <Col>
          {availableRequestNumbers && (
            <IntegratorDataSelector
              name="Request"
              data={availableRequestNumbers}
              handleTargetId={handleRequestChange}
              targetId={requestNumber}
            />
          )}
        </Col>
      </Row>
      <RequestResponseCard isLoading={isLoading} data={request} header="Request" />
      <RequestResponseCard isLoading={isLoading} data={response} header="Response" />
    </>
  );
};
